import axios from "axios";

const INVITES_URL = "api/v1/workspace-invites";
const MEMBERS_URL = "api/v1/workspace-members";

export const acceptInvite = (payload) => axios.post(`${INVITES_URL}/accept`, payload);
export const getInvites = (params) => axios.get(INVITES_URL, { params });
export const createInvite = (payload) => axios.post(INVITES_URL, payload);
export const resendInvite = (inviteId) => axios.post(`${INVITES_URL}/${inviteId}/resend`);
export const cancelInvite = (inviteId) => axios.post(`${INVITES_URL}/${inviteId}/cancel`);
export const getMembers = () => axios.get(MEMBERS_URL);
export const updateMember = (membershipId, payload) =>
  axios.patch(`${MEMBERS_URL}/${membershipId}`, payload);
export const disableMember = (membershipId) =>
  axios.patch(`${MEMBERS_URL}/${membershipId}/disable`);
export const enableMember = (membershipId) => axios.patch(`${MEMBERS_URL}/${membershipId}/enable`);
export const deleteMember = (membershipId) => axios.delete(`${MEMBERS_URL}/${membershipId}`);
export const resetMemberMfa = (membershipId) =>
  axios.post(`${MEMBERS_URL}/${membershipId}/reset-mfa`);
export const getMemberSessions = (membershipId) =>
  axios.get(`${MEMBERS_URL}/${membershipId}/sessions`);
export const revokeMemberSessions = (membershipId) =>
  axios.post(`${MEMBERS_URL}/${membershipId}/revoke-sessions`);
export const getWorkspaceRoles = () => axios.get("api/v1/workspace-roles");
export const getActivity = (params) => axios.get("api/v1/workspace-activity-logs", { params });
